import { getCollection } from '~/content/collections'
import WorkTile from './WorkTile'

// The /work landing grid. CSS Grid with dense auto-flow so the multi-column featured
// tiles pack in among the single-column ones (rather than all sitting at the top).
// Column gap is 1rem; the row gap is 9/16 of it (0.5625rem = 1rem * 9/16) so that a
// featured tile — which is `2*col + columnGap` wide at 16:9 — is exactly as tall as two
// stacked normal rows.
export default function WorkGrid() {
	const entries = getCollection('projects')

	return (
		<ul className="list-none m-0 p-0 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-[0.5625rem] grid-flow-row-dense">
			{entries.map((entry) => (
				<WorkTile key={entry.meta.slug} meta={entry.meta} />
			))}
		</ul>
	)
}
